<template>
  <div>
    <div id="editorElem" style="text-align:left"></div>
    <div class="mt-10 text-center" v-if="showOk">
      <el-button type="primary "  @click="confirm" >确定</el-button>
    </div>
  </div>

</template>
<script>
  import E from 'wangeditor'
  export default{
    name: 'editor',
    props:['img-url','value','img-type','show-confirm'],
    data(){
      return {
        editorContent: this.value || '',
        editor: {},
        params:{},
        type:this.imgType?'/'+this.imgType+'/' : '/',
        path:this.imgUrl || this.globalData.uploadHost,
        showOk:this.showConfirm || false
      }
    },
    mounted(){
      this.editorInit()
    },
    methods: {
      editorInit(){
        this.editor = new E('#editorElem')
        this.editor.customConfig.zIndex = 100
        this.editor.customConfig.menus = [
          'head',  // 标题
          'bold',  // 粗体
          'fontSize',  // 字号
          'fontName',  // 字体
          'italic',  // 斜体
          'underline',  // 下划线
          'strikeThrough',  // 删除线
          'foreColor',  // 文字颜色
          'backColor',  // 背景颜色
          'link',  // 插入链接
          'list',  // 列表
          'justify',  // 对齐方式
//          'quote',  // 引用
          'emoticon',  // 表情
          'image',  // 插入图片
          'table',  // 表格
          'video',  // 插入视频
//          'code',  // 插入代码
          'undo',  // 撤销
          'redo'  // 重复
        ]
        this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024
        this.editor.customConfig.onchange = (html) => {
          this.editorContent = html
        }
        this.editor.customConfig.customUploadImg =  (files, insert) => {
          this.getSignature(files[0],insert)
        }
        this.editor.create()
        $('.w-e-text-container').css('height','400px')
      },
      getSignature(file,insert){
        let suffix = file.name.lastIndexOf('.') >= 0 ? file.name.substring(file.name.lastIndexOf('.')) : '.png'
        let dir = '/' + this.$store.state.LoginUser.companyId + this.type + new Date().getTime() + suffix
        this.$http$({method: 'get', url: '/webServer/oss/sigle', backDirect: true}, (data) => {
          this.params = {
            key: data.dir + dir,
            policy: data.policy,
            OSSAccessKeyId: data.accessid,
            success_action_status: '200',
            callback: data.callback || '',
            signature: data.signature,
          }
          this.postImg(file,insert)
        })
      },
      postImg(file,insert){
        var fd = new FormData()
        for (var i in this.params) {
          fd.append(i, this.params[i])
        }
        fd.append('file', file)
        this.$http.post(this.path, fd)
          .then((ret) => ret.body)
          .then((data) => {
            insert(this.globalData.resourceUrl + this.params.key)

          })
          .catch(() => {
            this.$error('图片上传失败！')
          })
      },
      confirm(){
          this.$emit('on-confirm')
      }
    },
    watch:{
      editorContent(val){
        this.$emit('input',val)
      },
      value(val){
        this.editorContent = val
        this.editor.txt.html(val)
      },
    }
  }
</script>
<style>
  .w-e-text-container .w-e-panel-container .w-e-up-img-container .w-e-icon-upload2 {
    /*font-size: 60px;!important;*/
    font-size: 50px;
  }
  .w-e-up-img-container{
    border: 1px dashed #e5e5e5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Editor.vue